export default __webpack_public_path__ + "static/media/icon-192x192.58879bd5.png";